import { render, staticRenderFns } from "./downLoadCard.vue?vue&type=template&id=3b8e5b38&scoped=true&"
import script from "./downLoadCard.vue?vue&type=script&lang=js&"
export * from "./downLoadCard.vue?vue&type=script&lang=js&"
import style0 from "./downLoadCard.vue?vue&type=style&index=0&id=3b8e5b38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8e5b38",
  null
  
)

export default component.exports